module.exports = __webpack_public_path__ + "assets/auth-background-63423c29b7a29a959f49c4b1429b4e56.jpg";